<template>
  <DxPopup
    :visible="visible"
    :title="$t('scale.weighing_on_scale.password_dialog_title')"
    :width="360"
    height="auto"
    :drag-enabled="false"
    :close-on-outside-click="true"
    @hiding="$emit('update:visible', false)"
  >
    <div class="password-dialog-content">
      <label class="control-label">{{ $t('scale.weighing_on_scale.password_label') }}</label>
      <div class="password-input-wrapper">
        <input
          v-model="inputValue"
          :type="showPassword ? 'text' : 'password'"
          class="form-control"
          @keyup.enter="confirm"
        />
        <span class="password-toggle-icon" @click="showPassword = !showPassword">
          <i :class="showPassword ? 'fa-regular fa-eye-slash' : 'fa-regular fa-eye'"></i>
        </span>
      </div>
      <div v-if="hasError" class="password-error-msg">
        {{ $t('scale.weighing_on_scale.password_incorrect') }}
      </div>
      <div class="password-dialog-actions">
        <SmagriaButton
          :label="$t('scale.weighing_on_scale.password_confirm')"
          :action="confirm"
          :customClass="'primary password-confirm-button'"
        />
      </div>
    </div>
  </DxPopup>
</template>

<script>
import { DxPopup } from "devextreme-vue/popup";
import SmagriaButton from "@/components/Common/SmagriaButton.vue";

export default {
  name: "PasswordDialog",
  components: { DxPopup, SmagriaButton },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    expectedPassword: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      inputValue: "",
      showPassword: false,
      hasError: false,
    };
  },
  watch: {
    visible(val) {
      if (val) {
        this.inputValue = "";
        this.showPassword = false;
        this.hasError = false;
      }
    },
  },
  methods: {
    confirm() {
      if (this.inputValue === this.expectedPassword) {
        this.$emit("confirmed");
        this.$emit("update:visible", false);
      } else {
        this.hasError = true;
      }
    },
  },
};
</script>

<style scoped>
.password-dialog-content {
  padding: 10px 4px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.password-input-wrapper {
  position: relative;
  display: flex;
  align-items: center;
}

.password-input-wrapper .form-control {
  padding-right: 38px;
}

.password-toggle-icon {
  position: absolute;
  right: 10px;
  cursor: pointer;
  color: #555;
  font-size: 16px;
  user-select: none;
}

.password-toggle-icon:hover {
  color: #222;
}

.password-dialog-actions {
  display: flex;
  justify-content: stretch;
  width: 100%;
  margin-top: 6px;
}

.password-dialog-actions ::v-deep .password-confirm-button.smagria-btn {
  width: 100% !important;
  max-width: 100% !important;
  height: 40px !important;
  border: none !important;
  border-radius: 50px !important;
  background-color: #ea652a !important;
  color: #fff !important;
  font-weight: 700 !important;
  box-shadow: none !important;
}

.password-error-msg {
  color: #d9534f;
  font-size: 12px;
  font-weight: 600;
}
</style>
